<template>
  <div class="home-page">
    <!-- <div class="home-page__backdrop" /> -->
    <!--

    <div class="home-page__container">
      <div class="home-page__text">
        <a
          class="logo"
          href="#"
          @click.prevent.stop="$router.push('/')"
        >
          <MainLogo
            width="165"
            height="40"
          />
        </a>
        <div class="home-page__tagline-container">
          <h2 class="home-page__tagline mb-4">
            Approachable applications that reach your clients with curated content.
            Create powerful, personal connections to empower your sales team.
          </h2>

          <template v-if="user">
            <base-button
              class="ml-0"
              inverse
              @click="$router.push( (user.profile.role == 'manager')? '/admin/dashboard': '/dashboard')"
            >
              Go to {{ (user.profile.role == 'manager')? 'Dashboard': 'Activity' }}
            </base-button>
          </template>
          <template v-else>
            <base-button
              class="landing-button ml-0"
              inverse
              @click="$router.push('/login')"
            >
              SIGN IN
            </base-button>
          </template>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  computed: {
    user() {
      return this.$store.state.account.user;
    },
  },
  created() {
    if (!this.user) {
      this.$router.push({
        name: 'LoginPage',
      });
      return;
    }
    this.$router.push('/dashboard');
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Playfair+Display:400,400i");

.home-page {
    min-height: 100vh;
    margin-top: -60px;
    // background-color: #343a40;
    background-color: $bg-sales-associate;
    color: white;
    position: relative;

    .logo > div {
        width: 100%;
        height: 100;
        padding: 30px 0 20px 60px;
    }

    .landing-button {
        margin: 15px 0 0 10px !important;
        font-family: $font-family-sans-serif;
        letter-spacing: 1px;
    }

    &__backdrop {
        opacity: 0.5;
        position: absolute;
        left: 50%;
        right: 0;
        bottom: 0;
        top: 0;
        background-image: url(https://images.unsplash.com/photo-1445205170230-053b83016050?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1651&q=80);
        background-size: cover;
        background-position: center;
        // filter: blur(5px);
    }

    &__container {
        // max-width: 800px;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        position: absolute;
        padding: 20px;
        background: #F5EFEB;
        border-right: solid 2px #FFF;

        text-align: center;

        @media (min-width: 768px) {
            right: 30%;
            text-align: left;
        }

        @media (min-width: 820px) {
            right: 50%;
        }
    }

    &__text {
        color: #343a40;
        top: 50%;
        position: absolute;
        transform: translateY(-50%);
    }
    &__buttons {
        position: absolute;
        top: 10px;
        text-align: right;
        left: 0;
        right: 0;
    }

    &__tagline-container {
        margin-top: 0.1rem;
        /*margin-left: 10px;*/
        margin-right: 10px;
        max-width: 500px;

        @media (min-width: 768px) {
            margin-left: 75px;
        }
    }

    &__tagline {
        font-family: "Playfair Display", serif;
        font-style: italic;
        font-size: 1rem;
    }
}
</style>
